import { useCallback, useRef } from "react"

export function useObserveRefCallback(observer: IntersectionObserver): (node: Element | null) => void {
  const observedElementRef = useRef<Element | null>(null)

  return useCallback((node: Element | null) => {
    if (observedElementRef.current && observedElementRef.current !== node) observer.unobserve(observedElementRef.current)
    observedElementRef.current = node

    if (node) {
      observer.observe(node)
    }
  }, [observer])
}